import * as React from 'react';
import { useSelector } from 'react-redux';
import { descriptionSelector } from '../../selectors';
import { Description } from '../../components/Description';

export const DescriptionContainer = () => {
  const description = useSelector(descriptionSelector);

  return <Description description={description} />;
};
